import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";
import cx from "classnames";

import Actions from "modules/diagnostic/diagnostic-actions";

import FormattedMessageHtml from "modules/i18n/formatted-message-html";
import { OpenedBook } from "../icons";

function CheckboxCircle(props) {
  return (
    <div className="CheckboxCircle">
      <input className="CheckboxCircle__Input" {...props} />
      <label className="CheckboxCircle__Label" htmlFor={props.id} />
    </div>
  );
}

class Consent extends Component {
  static propTypes = {
    onNext: PropTypes.func.isRequired,
    consentMedical: PropTypes.func.isRequired,
    consentPrivacy: PropTypes.func.isRequired,
    consentTerms: PropTypes.func.isRequired,
    intl: intlShape
  };
  constructor(props) {
    super(props);
    this.state.chkbox1 = false;
    this.state.chkbox2 = false;
    this.state.chkbox3 = false;
  }
  state = {
    chkbox1: false,
    chkbox2: false,
    chkbox3: false
  };

  handleChangeChk(a, checkbox) {
    this.setState({
      [checkbox]: !this.state[checkbox]
    });
  }

  render() {
    const { chkbox1, chkbox2, chkbox3 } = this.state;
    const { consentMedical, consentPrivacy, consentTerms } = this.props;

    return (
      <Fragment>
        <div className="modal consent-modal">
          <div className="consent-modal__title">
            <FormattedMessage id="consent.title" />
          </div>
          <FormattedMessageHtml
            element="p"
            className="consent-modal__description"
            id="consent.desc"
          />
          <div className="consent-modal__consents-list">
            <div
              className={cx(`consent-modal__item`, {
                "consent-modal__item--checked": this.state.chkbox1
              })}
            >
              <CheckboxCircle
                type="checkbox"
                id="checkbox1"
                checked={this.state.chkbox1}
                onChange={e => this.handleChangeChk(e, "chkbox1")}
              />
              <p
                className="consent-modal__item-title"
                onClick={e => this.handleChangeChk(e, "chkbox1")}
              >
                <FormattedMessage id="consent.checkbox.medical" />
              </p>
              <div className="consent-modal__item-description">
                <FormattedMessage id="consent.checkbox.medical.description" />
              </div>
              <div
                className="consent-modal__item-icon-container"
                onClick={() => consentMedical()}
              >
                <OpenedBook
                  className="consent-modal__item-icon"
                  width={30}
                  height={30}
                />
                <div className="consent-modal__item-icon-title">
                  <FormattedMessage id="consent.checkbox.medical" />
                </div>
              </div>
            </div>
            <div
              className={cx(`consent-modal__item`, {
                "consent-modal__item--checked": this.state.chkbox2
              })}
            >
              <CheckboxCircle
                type="checkbox"
                id="checkbox2"
                checked={this.state.chkbox2}
                onChange={e => this.handleChangeChk(e, "chkbox2")}
              />
              <p
                className="consent-modal__item-title"
                onClick={e => this.handleChangeChk(e, "chkbox2")}
              >
                <FormattedMessage id="consent.checkbox.terms" />
              </p>
              <div className="consent-modal__item-description">
                <FormattedMessage id="consent.checkbox.terms.description" />
              </div>
              <div
                className="consent-modal__item-icon-container"
                onClick={() => consentTerms()}
              >
                <OpenedBook
                  className="consent-modal__item-icon"
                  width={30}
                  height={30}
                />
                <div className="consent-modal__item-icon-title">
                  <FormattedMessage id="consent.checkbox.terms" />
                </div>
              </div>
            </div>
            <div
              className={cx(`consent-modal__item`, {
                "consent-modal__item--checked": this.state.chkbox3
              })}
            >
              <CheckboxCircle
                type="checkbox"
                id="checkbox3"
                checked={this.state.chkbox3}
                onChange={e => this.handleChangeChk(e, "chkbox3")}
              />
              <p
                className="consent-modal__item-title"
                onClick={e => this.handleChangeChk(e, "chkbox3")}
              >
                <FormattedMessage id="consent.checkbox.privacy" />
              </p>
              <div className="consent-modal__item-description">
                <FormattedMessage id="consent.checkbox.privacy.description" />
              </div>
              <div
                className="consent-modal__item-icon-container"
                onClick={() => consentPrivacy()}
              >
                <OpenedBook
                  className="consent-modal__item-icon"
                  width={30}
                  height={30}
                />
                <div className="consent-modal__item-icon-title">
                  <FormattedMessage id="consent.checkbox.privacy" />
                </div>
              </div>
            </div>
          </div>
          <div className="next">
            <button
              className="Button--wide blue"
              disabled={!chkbox1 || !chkbox2 || !chkbox3}
              onClick={this.props.onNext}
            >
              <FormattedMessage id="consent.button" />
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = {
  consentMedical: Actions.Creators.consentMedical,
  consentPrivacy: Actions.Creators.consentPrivacy,
  consentTerms: Actions.Creators.consentTerms
};

Consent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Consent);

export default injectIntl(Consent);



// WEBPACK FOOTER //
// ./src/modules/general-info/consent.js